module.exports = __webpack_public_path__ + "static/logo-city-b1599268491d9e1064a80fced76bfb73.png";